import { writable } from "svelte/store"

export class bulkObj {
  constructor() {
    this.invalidObj = {}
  }
}

/**
 * @type {BulkUploadFlow}
 */
let bulkUpload = localStorage.getItem("P2BBulkUpload")

if (typeof bulkUpload != "Object") {
  try {
    bulkUpload = JSON.parse(bulkUpload)
    if (!bulkUpload) {
      throw new Error("P2BBulkUpload value is null")
    }
  } catch (error) {
    bulkUpload = new bulkObj()
  }
}

/**
 * @typedef {Object} bulkUploadState - represents the current bulk Upload data
 * @type {Object}
 * represents the current bulk Upload data
 *
 * @property {Object} invalidObj - invalid values in excel sheet
 */

/**
 * @typedef {Object} BulkUploadFlow - represents the bulk upload publishing process
 * @type {Object}
 * represents the bulk upload publishing process
 *
 * @property {bulkUploadState} bulkUploadState - represents the individual session values
 */

/**
 * @type {import("svelte/store").Writable<BulkUploadFlow>}
 */

const bulkUploadOperations = writable(bulkUpload)

/**
 * updating the bulk upload publishing process variables to the local Storage
 * @param {BulkUploadFlow} Bulk
 */
export const updateLocalStorage = (Bulk) => {
  localStorage.setItem("P2BBulkUpload", JSON.stringify(Bulk))
}

export default bulkUploadOperations
